import Vue from 'vue'
import Vuex from 'vuex'
import store from '@/store'
import CustomerStore from '@/store/user/customer'

const STYLIST_LIST_SEARCH_TESTER_PUBLIC_URL = 'https://cdn.quartic.com.pl/search/v3_app/stylizations_list.html'

Vue.use(Vuex)

interface StylizationList {
  customerSymbol: string | null
  searchId: string | null
  authKey: string | null
  isAuthDataReady: boolean
  isFrameLoaded: boolean
  searchTesterUrl: string | null
}

export default new Vuex.Store({
  state: (): StylizationList => ({
    authKey: null,
    searchId: null,
    customerSymbol: null,
    isAuthDataReady: false,
    isFrameLoaded: false,
    searchTesterUrl: null,
  }),
  mutations: {
    setCustomerSymbol(state: StylizationList, customerSymbol: string) {
      state.customerSymbol = customerSymbol
    },
    setSearchId(state: StylizationList, searchId: string) {
      state.searchId = searchId
    },
    setAuthReady(state: StylizationList, isAuthDataReady: boolean) {
      state.isAuthDataReady = isAuthDataReady
    },
    setFrameLoaded(state: StylizationList, isFrameLoaded: boolean) {
      state.isFrameLoaded = isFrameLoaded
    },
  },
  actions: {
    async getApiAuthorizationKey() {
      await store.dispatch('authorizationKey/getData')
        .then((response: { key: string }) => {
          this.state.authKey = response.key
        })
    },

    loadedFrame(context: any, { searchId, frame }) {
      if (!context.state.isFrameLoaded) {
        context.commit('setFrameLoaded', true)
        context.dispatch('changeSearchIdFrameTester', { searchId, frame })
      }
    },

    async changeSearchIdFrameTester(context: any, { searchId, frame }) {
      if (!context.state.isFrameLoaded) {
        return
      }
      if (context.state.authKey === null) {
        await context.dispatch('getApiAuthorizationKey')
      }
      if (context.state.customerSymbol === null) {
        context.commit('setCustomerSymbol', CustomerStore.state.customerSymbol)
      }
      context.commit('setSearchId', searchId)
      context.commit('setAuthReady', true)
      await context.dispatch('sendSearchInformationToFrame', frame)
    },

    sendSearchInformationToFrame(context: any, frame: HTMLIFrameElement) {
      if (!frame.contentWindow) {
        return
      }
      frame.contentWindow.postMessage({
        customerSymbol: context.state.customerSymbol,
        searchId: context.state.searchId,
        apiKey: context.state.authKey,
      }, '*')
    },
  },
  getters: {
    getFrameStylizationsListUrl() {
      return STYLIST_LIST_SEARCH_TESTER_PUBLIC_URL
    },
  },
})
